import React from 'react';
import Waiter from "../../controls/Waiter.mjs";
import "./Linkset.css";
import {UncontrolledTooltip} from "reactstrap";
import AutoIcon from "../../controls/AutoIcon.mjs";
import {Glob as G} from "../../libs/Glob.mjs";
import appLib from "../../libs/appLib.mjs";

const baseName='Linkset';

const handleUri = (uri, local) => {
	if ( typeof uri !== "string" ) return;
	if ( uri.startsWith("http") || uri.startsWith("/") ) {
		if ( local ) {
			window.location.href = uri;
			return;
		}
		return window.open(uri,'foo','toolbar=1');
	}
	// eslint-disable-next-line
	if ( uri.startsWith("javascript:") ) return eval( uri.replace(/^javascript:/,''));
	window.location.href = uri;
}

const Linkset = class Linkset extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			lan: G.prop.isLAN,
			wan: ! G.prop.isLAN
		};
		if ( this.props.data?.links ) {
			this.state.list = this.props.data.links;
			this.state.label = this.props.data.label;
		}
		this.uid=G.generateUid(baseName);
		this.load = this.load.bind(this);
	}
	componentDidMount() {
		setTimeout( this.load );
	}
	async load() {
		const all = await appLib.data('links');
		const lset = all[ this.props.set ];
		const links = (lset && lset?.links && lset?.links.length ? lset.links : [])
			.filter( l => ( (l.lan && this.state.lan) || ( l.wan && this.state.wan ) || ( ! l.lan && ! l.wan ) ) );
		if ( links.length ) {
			this.setState({list: links, label: lset.label, loaded: true });
		} else {
			this.setState({list: false, loaded: true});
		}
	}
	render() {
		if ( ! this.state.loaded ) {
			return(
				<div className={"text-center"}>
					<Waiter />
				</div>
			);
		}
		if ( ! this.state.list ) return '';
		return(
			<div className={baseName} id={this.uid}>
				{ this.state.list.map( ( link, index ) => (
					<div
						className={baseName+"Item"}
						id={this.uid+'-'+index}
						key={ index }
						onClick={ () => { handleUri(link.uri, link.local) } }
					>
						<div className={"icon"}>
							<AutoIcon value={ link.icon } />
						</div>
						<div className={"name"}>{link.name}</div>
						{ link.desc && (
							<UncontrolledTooltip
								target={this.uid+'-'+index}
								placement={"auto"}
							>
								{link.desc}
							</UncontrolledTooltip>
						)}
					</div>
				))}
			</div>
		)
	}
}

export default Linkset;